export const RECEIVE_INITIAL_STATE_SUCCESS = 'RECEIVE_INITIAL_STATE_SUCCESS'
export const UPDATE_MERCHANT = 'UPDATE_MERCHANT'
export const LOADING_MERCHANT = 'LOADING_MERCHANT'
